import { render, staticRenderFns } from "./Reddit.vue?vue&type=template&id=822d2090"
import script from "./Reddit.vue?vue&type=script&lang=js"
export * from "./Reddit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports